// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"493":"6ac84478","546":"6ac84478","737":"6ac84478"}[chunkId] + ".chunk.css";
};